module.exports = __webpack_public_path__ + "static/media/scheduling_blue.17403243.png";